export interface AuthenticationAPISolarmanResponse {
  code: string | null;
  msg: string | null;
  success: boolean;
  requestId: string;
  access_token: string;
  token_type: string;
  refresh_token: string;
  expires_in: string;
  scope: string | null;
  uid: number;
}

export interface CallAPISolarmanDeviceInfoResponse {
  code: string | null;
  msg: string | null;
  success: boolean;
  requestId: string;
  communication: Communication;
}

export interface CallAPISolarmanModbusResponse {
  code: string | null;
  msg: string | null;
  success: boolean;
  requestId: string;
  orderId: number;
  collectionTime: number;
  connectStatus: number;
}

export interface Communication {
  deviceSn: string;
  deviceId: number;
  parentSn: string;
  deviceType: string;
  deviceState: number;
  updateTime: number;
  timeZone: string;
  childList: ChildDevice[];
}

export interface ChildDevice {
  deviceSn: string;
  deviceId: number;
  parentSn: string;
  deviceType: string;
  deviceState: number;
  updateTime: number;
  timeZone: string;
  childList: null;
}

export interface AppsyncModbusResponse {
  ack: string;
  analysisResult: string | null;
  content: string;
  createTime: number;
  deviceId: number;
  deviceSN: string | null;
  orderId: number;
  success: boolean;
  updateTime: number;
}

export interface CallPROSolarmanDeviceDetailsResponse {
  deviceId: number;
  deviceSn: string;
  siteId: number;
  productId: string;
  timeZone: string;
  name: null | string;
  type: string;
  connectStatus: number;
  alertStatus: number;
  collectionTime: number;
  activationState: number;
  deviceState: number;
  parDeviceId: number;
  parDeviceSn: string;
  paramCategoryList: ParamCategoryList[];
  alertStatusWithin: number;
  alertStatusOutside: number;
  alertStatusUser: number;
}

export interface ParamCategoryList {
  name: string;
  serialNumber: number;
  fieldList: FieldList[];
  tag: string;
}

export interface FieldList {
  key: string;
  value: string;
  storageName: string;
  unit?: string;
  serialNumber: number;
}

export interface CallPROSolarmanFirmwareDetailsResponse {
  createdBy: number;
  createdDate: number;
  lastModifiedBy: number;
  lastModifiedDate: number;
  id: number;
  version: string;
  name: string;
  filePath: string;
  fileName: string;
  uploadFileName: string;
  deviceType: number;
  dataloggerUpdateCode: string;
  deviceUpdateCode: string;
  companyId: number;
  convertType: any;
  sourceFilePath: any;
  versionKey: string;
  matchProduct: string;
  matchFirmwareVersion: string;
  matchHardwareVersion: string;
  matchModel: string;
  otherMatchCondition: any;
  firmwarePath: any;
  firmwareType?: string;
  baudRate?: string;
  baudParam: any;
  upgradeModeCode: any;
  specialUpdateCode?: string;
  versionDescribe?: string;
  localUpgrade?: string;
  releaseState: number;
  deviceClassification: number;
  fileSize: number;
}

export interface CallPROSolarmanUpgradeFirmwareResponse {
  currentTimeMillis: number;
  id: number | null;
  checkMaxSeconds: number | null;
}

export interface CallPROSolarmanLastActionResponse {
  orderId: number;
  content: any;
  deviceType: number;
  deviceTypeEnum: string;
  orderType: number;
  operationType: any;
  orderTimeout: number;
  gatewaySn: string;
  gatewayId: number;
  deviceSn: string;
  deviceId: number;
  groupCode: string;
  analysisResult: string;
  extendWeb: any;
  status: number;
  ack: any;
  createBy: number;
  createByName: any;
  createTime: number;
  updateTime: number;
  firmwareId: number;
  firmwareName: string;
  version: string;
  versionKey: string;
  versionKeyName: string;
  error: any;
  companyId: number;
  companyName: any;
  deviceTimezone: string;
  supportProgressDisplay: number;
  currentProgress: string;
  extend: string;
  releaseState: any;
  deviceClassifications: any;
  firmwareClassifications: any;
  beforeVersion: string;
  afterVersion: string;
  operatorScope: any;
}

export enum SolarmanDeviceStatus {
  Online = 1,
  Alarm = 2,
  Offline = 3,
}

export interface CallAPISolarmanCurrentDataResponse {
  code: string | null;
  msg: string | null;
  success: boolean;
  requestId: string;
  deviceId: number;
  deviceSn: string;
  deviceState: number;
  deviceType: string;
  collectionTime: number;
  dataList: SolarmanDataListItem[];
}

export interface SolarmanDataListItem {
  key: string;
  name: string;
  unit: string | null;
  value: string;
}
